var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add"},[_c('form-info',{attrs:{"formData":_vm.formData,"isEdit":false,"testData":_vm.testData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }